import { useEffect } from 'react';
import { useAppDispatch } from 'src/store/baseHooks';
import { setActiveTabFunctions } from 'src/store/slices/uiFlowSlice';

/**
 *  Register functions defined within a component to be accessed by the ItemViewToolbar.
 *
 * @param functionObject
 */
export const useRegisterActiveTabFunctions = (functionObject: { [key: string]: (t?: any) => any }, id = '') => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch?.(setActiveTabFunctions(functionObject));

    return () => {
      dispatch?.(setActiveTabFunctions({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
};
